export default __webpack_public_path__ + "static/media/Feature_parking.bcd1bedb.svg";